<div class="wrap">
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol>
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><a (click)="this.returnToList()" style="cursor: pointer;">Partners</a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Partner Details</span></li>
                    </ol>
                </div>
                <div *ngIf="this.isLoadingDetail" class="profile-holder skeleton-detail">
                    <div class="profile">
                        <div class="pfp"><div class="skeleton-block skeleton-avatar"></div></div>
                        <div class="profile-info">
                            <div class="skeleton-block skeleton-line" style="width: 220px; height: 20px;"></div>
                            <div class="skeleton-block skeleton-line" style="width: 140px; height: 14px; margin-top: 10px;"></div>
                        </div>
                    </div>
                </div>
                <div *ngIf="this.isLoadingDetail" class="panel">
                    <div class="skeleton-block skeleton-line" style="width: 100%; height: 40px; margin-bottom: 12px;" *ngFor="let skeletonRow of [1,2,3,4,5]"></div>
                </div>

                <div *ngIf="!this.isLoadingDetail" class="profile-holder">
                    <div class="profile">
                        <div class="pfp">
                            <a *ngIf="this.clickableProfileImage; else nonClickableImage" (click)="viewLargerModal(viewProfileImage)" style="cursor: pointer;" target="_blank" class="docs">
                                <img [src]="this.profileImage">
                            </a>
                            <ng-template #nonClickableImage>
                                <img src="../../../../assets/okito/images/avatar.png">
                            </ng-template>
                        </div>
                        <div class="profile-info">
                            <h4>{{ this.detailViewed['firstName'] + ' ' + this.detailViewed['middleName'] + ' ' + this.detailViewed['lastName'] }}</h4>
                            <div class="tags">
                                <span class='stat-icon' *ngIf="this.detailViewed['status'] == 'approved'; else showNotVerified"><img src="../../../../assets/okito/images/badge/verified.svg"> Approved</span>

                                <ng-template #showNotVerified>
                                    <span class="stat-icon"><img src="../../../../assets/okito/images/badge/not-verified.svg">Not Approved Yet</span>
                                </ng-template>
                                <span class="stat-icon"><img src="../../../../assets/okito/images/badge/vehicle.svg">{{ this.detailViewed['vehicleType'] }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="profile-actions" *ngIf="this.enableEdit; else disableEdit">
                        <button class="btn btn-sm btn-default" style="margin-right: 1em;" (click)="disableEditForm()">Cancel Edit</button>
                        <button class="btn btn-sm btn-default" style="margin-right: 1em;" (click)="updateThisDetails()">Save Details</button>
                    </div>

                    <ng-template #disableEdit>
                        <div class="profile-actions">
                            <button *ngIf="this.detailViewed['status'] == 'approved' && !this.documentUpdateMode" class="btn btn-sm btn-default" style="margin-right: 1em;" (click)="openOverrideModal(overrideModal)">Updated Document Details</button>
                            <button *ngIf="this.detailViewed['status'] == 'approved' && this.documentUpdateMode" class="btn btn-sm btn-default" style="margin-right: 1em;" (click)="endDocumentUpdateMode()">Updating Document Done</button>
                            <button class="btn btn-sm btn-default" style="margin-right: 1em;" (click)="enableEditForm()">Edit Partner</button>
                            <button class="btn btn-sm btn-default" (click)="this.returnToList()">Return to List</button>
                        </div>
                    </ng-template>
                </div>
                <div *ngIf="!this.isLoadingDetail" class="list-tabs">
                    <ul>
                        <li [ngClass]="{'active': this.detailTabs['personal']}"><a (click)="setTabPanelActive('personal')" style="cursor: pointer;">Personal Information</a></li>
                        <li [ngClass]="{'active': this.detailTabs['service_details']}"><a (click)="setTabPanelActive('service_details')" style="cursor: pointer;">Service Details</a></li>
                        <li [ngClass]="{'active': this.detailTabs['documents']}"><a (click)="setTabPanelActive('documents')" style="cursor: pointer;">Documents</a></li>
                        <li [ngClass]="{'active': this.detailTabs['transactions']}"><a (click)="setTabPanelActive('transactions')" style="cursor: pointer;">Transactions</a></li>
                        <li [ngClass]="{'active': this.detailTabs['topups']}"><a (click)="setTabPanelActive('topups')"
                                style="cursor: pointer;">Topup</a></li>
                        <li [ngClass]="{'active': this.detailTabs['withdrawals']}"><a (click)="setTabPanelActive('withdrawals')"
                                style="cursor: pointer;">Withdrawals</a></li>
                        <li [ngClass]="{'active': this.detailTabs['activity']}"><a (click)="setTabPanelActive('activity')" style="cursor: pointer;">Activity History</a></li>
                    </ul>
                </div>
                <div class="panel" *ngIf="!this.isLoadingDetail && this.detailTabs['personal']">
                    <h3>Personal Information</h3>
                    <div class="panel-info">
                        <div class="panel-grp">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Email</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" [disabled]="!enableEdit"  [(ngModel)]="this.detailViewed['email']">
                                </div>
                            </div>
                        </div>
                        <div class="panel-grp">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Mobile Number</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" disabled [(ngModel)]="this.detailViewed['mobile']">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel" *ngIf="!this.isLoadingDetail && this.detailTabs['service_details']">
                    <h3>Service Details</h3>
                    <div class="panel-info">
                        <div class="panel-grp" *ngIf="isTaxiService">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Enrollment Status</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" disabled [value]="enrollmentStatusLabel">
                                </div>
                            </div>
                        </div>
                        <div class="panel-grp">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Service Type</label>
                                <div class="col-sm-10">
                                    <div class="form-check form-check-inline" *ngFor="let service of serviceTypeOptions">
                                        <input class="form-check-input" type="checkbox" [id]="service.id" disabled [checked]="service.checked">
                                        <label class="form-check-label" [for]="service.id">{{ service.label }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-grp">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Service Area</label>
                                <div class="col-sm-10">
                                    <div class="row">
                                        <div class="col-md">
                                            <input type="text" class="form-control" disabled [(ngModel)]="this.detailViewed['distributionArea']">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-grp">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Plate Number/Conduction Number</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" disabled [value]="isTaxiService ? plateOrConductionNumber : detailViewed['licensePlate']">
                                </div>
                            </div>
                        </div>
                        <div class="panel-grp">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Vehicle Type</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" disabled [(ngModel)]="this.detailViewed['vehicleType']">
                                </div>
                            </div>
                        </div>
                        <div class="panel-grp" *ngIf="isTaxiService">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Fleet Operator</label>
                                <div class="col-sm-10">
                                    <input type="text" class="form-control" disabled [value]="fleetOperatorName">
                                </div>
                            </div>
                        </div>
                        <div class="panel-grp" *ngIf="isTaxiService">
                            <div class="mb-3 row">
                                <label class="col-sm-2 col-form-label">Vehicle Details</label>
                                <div class="col-sm-10">
                                    <button type="button" class="btn btn-sm btn-outline" (click)="openVehicleDetailsModal(vehicleDetailsModal)">View Vehicle Details</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel" *ngIf="!this.isLoadingDetail && this.detailTabs['documents']">
                    <div class="list-holder">
                        <div class="tools">
                            <div class="list-title">
                                <h4>List of Documents</h4>
                            </div>

                            <div class="actions">
                                <button class="btn btn-sm btn-default" [disabled]="!canAddDocument" (click)="showAddDocumentModal(addDocument)"><i class="fa fa-plus"></i> Add Document</button>
                                &nbsp;
                                <button class="btn btn-sm btn-default" [disabled]="!checkIfAvailableforApproval('document_confirmation')" (click)="sendFollowUpNotification(this.detailViewed['partnerId'], successModal)"><i class="fa fa-send"></i> Send Document Confirmation</button>
                                &nbsp;
                                <button [disabled]="!checkIfAvailableforApproval() || this.detailViewed['status'] == 'approved'" (click)="showConfirmModal(confirmModal, 'verify_partner')" class="btn btn-sm btn-default"><i class="fa fa-check"></i> Approve Partner</button>
                                <ng-container *ngIf="this.partnerAuditTrails.length">
                                    &nbsp;
                                    <button class="btn btn-sm btn-default" (click)="viewAccountAuditTrail(accountAuditModal)"><i class="fa fa-history"></i> Document Audit Trail</button>
                                </ng-container>
                            </div>
                        </div>
                        <div class="list table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Document</th>
                                        <th>Part</th>
                                        <th>Document Reference</th>
                                        <th>Expiration Date</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="this.detailViewdDocuments.length != 0; else noRecords5">
                                        <ng-container *ngFor="let docs of this.detailViewdDocuments">
                                        <tr>
                                            <td>{{ this.verifyDocumentName(docs.type) }}</td>
                                            <td>{{ ((docs.type === docs.subType) ? '-' : this.subDocumentDictionary[docs.subType]) }}</td>
                                            <td
                                                *ngIf="(docs.type == 'drivers_license' && docs.subType == 'front') || (docs.type == 'vehicle_registration' && docs.subType == 'official_receipt') || (docs.type == 'vehicle_registration' && docs.subType == 'certificate_registration'); else noIDRef">
                                                {{ docs.idNumber }}</td>
                                            <ng-template #noIDRef>
                                                <td>-</td>
                                            </ng-template>
                                            <td *ngIf="(docs.type == 'drivers_license' && docs.subType == 'front'); else noExpDate">{{ docs.expirationDate }}
                                            </td>
                                            <ng-template #noExpDate>
                                                <td>-</td>
                                            </ng-template>
                                            <td>
                                                <span class="stat stat-pending" *ngIf="docs.status == 'pending'">Pending</span>
                                                <span class="stat stat-amend" *ngIf="docs.status == 'ammendment'">For Amendment</span>
                                                <span class="stat stat-amend" *ngIf="docs.status == 'resubmission'">For Resubmission</span>
                                                <span class="stat stat-approved" *ngIf="docs.status == 'approve'">Approved</span>
                                            </td>
                                            <td>
                                                <div class="doc-actions">
                                                    <button *ngIf="!this.documentUpdateMode" (click)="viewDocument(docModalView, docs)"
                                                        class="btn btn-sm btn-default"><i class="fa fa-eye"></i>&nbsp;View</button>
                                                    <button *ngIf="this.documentUpdateMode" (click)="editDocument(docModalView, docs)"
                                                        class="btn btn-sm btn-default"><i class="fa fa-pencil"></i>&nbsp;Edit</button>
                                                    <button *ngIf="hasDocumentTrail(docs)" (click)="viewDocumentHistory(docHistoryModal, docs)"
                                                        class="btn btn-sm btn-default"><i class="fa fa-history"></i>&nbsp;View History</button>
                                                    <button (click)="confirmRemoveDoc(docs, confirmModal)" class="btn btn-sm btn-danger"><i class="fa fa-trash-o"></i>&nbsp;Remove</button>
                                                </div>
                                            </td>
                                        </tr>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #noRecords5>
                                        <tr>
                                            <td colspan="8" class="no-records-msg">
                                                <h6 class="ponds-contents-med-bold">No records found</h6>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="panel" *ngIf="!this.isLoadingDetail && this.detailTabs['transactions']">
                    <div class="list-holder">
                        <select class="form-select" style="width:30%;margin-right:10px;" [(ngModel)]="this.selectedServiceType"
                            (ngModelChange)="onServiceTypeChange($event)">
                            <option value="express">OK! Express</option>
                            <option value="okride">OK! Ride</option>
                            <option value="mototaxi">OK! MotoTaxi</option>
                        </select>
                        <div class="tools">
                            <div class="search mg-right-auto">
                                <img src="../../../../assets/okito/images/icons/magnifying.svg">
                                <input (input)="searchDataBooking($event)" [(ngModel)]="this.searchKeywordBooking" type="text" class="text-search"
                                    placeholder="Search">
                            </div>

                            <div class="search mg-right-auto" style="width:58%; ">
                                <span style="font-weight:bold;margin-right:10px;margin-left:20px;">Sorting: </span>
                                <select class="form-select" style="width:30%;margin-right:10px;" [(ngModel)]="bookingSortBy"
                                    (ngModelChange)="onBookingSortChange()">
                                    <option value="dateCreated">Date Created</option>
                                    <option value="status">Status</option>
                                </select>

                                <div class="btn-group" role="group" aria-label="Sort by.." style="width:5%;">
                                    <button type="button" [ngClass]="{'active': bookingSortDirection === 'asc'}" class="btn btn-secondary"
                                        (click)="bookingSortDirection = 'asc'; onBookingSortChange()">Ascending</button>
                                    <button type="button" [ngClass]="{'active': bookingSortDirection === 'desc'}" class="btn btn-secondary"
                                        (click)="bookingSortDirection = 'desc'; onBookingSortChange()">Descending</button>
                                </div>
                            </div>
                            <div class="actions">
                                <button class="btn btn-sm btn-default">Download</button>
                            </div>
                        </div>


                    <div class="list table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>Booking ID</th>
                                    <th>Sender</th>
                                    <th>Mobile #</th>
                                    <th>Date of Completion</th>
                                    <th>Vehicle Type</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="currentBookingSelectedPageListTopups.length != 0; else noRecords4">
                                    <tr *ngFor="let booking of this.currentBookingSelectedPageListTopups">
                                        <td>{{ (selectedServiceType == 'express') ? booking.bookingExpressId : booking.bookingRideId }}</td>
                                        <td>{{ booking.user.name }}</td>
                                        <td>{{ booking.user.mobile }}</td>
                                        <td>{{ booking.dateCompleted | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A'}}</td>
                                        <td>{{ booking.partner.vehicleType }}</td>
                                        <td>
                                            <span class='stat stat-amend' *ngIf="booking.status == 'canceled'">Cancelled</span>
                                            <span class='stat stat-active' *ngIf="booking.status == 'pending'">Pending</span>
                                            <span class='stat stat-amend' *ngIf="booking.status == 'accepted'">Accepted</span>
                                            <span class='stat stat-amend' *ngIf="booking.status == 'ongoing_pickup'">On Going Pickup</span>
                                            <span class='stat stat-approved' *ngIf="booking.status == 'arrive_pickup'">Arrived Pickup</span>
                                            <span class='stat stat-approved' *ngIf="booking.status == 'ongoing_destination'">Ongoing Destination</span>
                                            <span class='stat stat-approved' *ngIf="booking.status == 'drop_off'">Drop Off</span>
                                            <span class='stat stat-approved' *ngIf="booking.status == 'completed'">Completed</span>
                                        </td>
                                        <td><a (click)="viewBookingDetails(booking, bookingDetail, selectedServiceType)" style="cursor: pointer;">View</a></td>
                                    </tr>
                                </ng-container>
                                <ng-template #noRecords4>
                                    <tr>
                                        <td colspan="8" class="no-records-msg">
                                            <h6 class="ponds-contents-med-bold">No records found</h6>
                                        </td>
                                    </tr>
                                </ng-template>

                            </tbody>
                        </table>
                    </div>
                    <div class="list-footer">
                        <div class="pager">
                            <button (click)="nextPrevBooking('prev')" [disabled]="this.disableActionBtnsBooking.prev"><img
                                    src="../../../../assets/okito/images/icons/prev.svg"></button>
                            <button (click)="nextPrevBooking('next')" [disabled]="this.disableActionBtnsBooking.next"><img
                                    src="../../../../assets/okito/images/icons/next.svg"></button>
                        </div>
                    </div>
                    </div>
                </div>

                <div class="panel" *ngIf="!this.isLoadingDetail && this.detailTabs['topups']">
                    <div class="list-holder">
                        <div class="tools">
                            <div class="tools-grp">
                                <div class="search" style="width: 20em !important;">
                                    <img src="../../../../assets/okito/images/icons/magnifying.svg">
                                    <input (input)="searchTopUpData($event)" [(ngModel)]="this.searchKeywordTopup" type="text"
                                        class="text-search" placeholder="Search">
                                </div>
                            </div>
                            <div class="tools-grp">
                                <div class="actions">
                                    <button class="btn btn-sm btn-default" data-bs-toggle="modal" data-bs-target="#create">Download</button>
                                </div>
                            </div>
                        </div>
                        <div class="list">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Transaction ID</th>
                                        <th>Partner's Mobile Number</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Top-up Type</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="currentSelectedPageListTopups.length != 0; else noRecords2">
                                        <tr *ngFor="let topup of this.currentSelectedPageListTopups">
                                            <td>{{ topup.partnerTopupRequestId }}</td>
                                            <td>{{ topup.partner.mobile }}</td>
                                            <td>{{ topup.dateCreated }} </td>
                                            <td>{{ topup.amount | currency:'PHP' }}</td>
                                            <td>{{ topup.source }}</td>
                                            <td><a (click)="viewTopupDetails(topup, topupDetails)" style="cursor: pointer;">View</a></td>
                                        </tr>
                                    </ng-container>
                                    <ng-template #noRecords2>
                                        <tr>
                                            <td colspan="8" class="no-records-msg">
                                                <h6 class="ponds-contents-med-bold">No records found</h6>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                        <div class="list-footer">
                            <div class="pager">
                                <button (click)="nextPrevTopups('prev')" [disabled]="this.disableActionBtnsTopups.prev"><img
                                        src="../../../../assets/okito/images/icons/prev.svg"></button>
                                <button (click)="nextPrevTopups('next')" [disabled]="this.disableActionBtnsTopups.next"><img
                                        src="../../../../assets/okito/images/icons/next.svg"></button>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="panel" *ngIf="!this.isLoadingDetail && this.detailTabs['withdrawals']">
                    <div class="list-holder">
                        <div class="tools">
                            <div class="tools-grp">
                                <div class="search" style="width: 20em !important;">
                                    <img src="../../../../assets/okito/images/icons/magnifying.svg">
                                    <input (input)="searchWithdrawalData($event)" [(ngModel)]="this.searchKeywordWithdrawal" type="text" class="text-search"
                                        placeholder="Search">
                                </div>
                            </div>
                            <div class="tools-grp">
                                <div class="actions">
                                    <button class="btn btn-sm btn-default" data-bs-toggle="modal"
                                        data-bs-target="#create">Download</button>
                                </div>
                            </div>
                        </div>
                        <div class="list">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Transaction ID</th>
                                        <th>Partner's Mobile Number</th>
                                        <th>Approved</th>
                                        <th>Requested</th>
                                        <th>Amount</th>
                                        <th>Top-up Type</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="currentSelectedPageListWithdrawals.length != 0; else noRecords3">
                                        <tr *ngFor="let withdraw of this.currentSelectedPageListWithdrawals">
                                            <td>{{ withdraw.partnerWalletRequestId }}</td>
                                            <td>{{ withdraw.accountName }}</td>
                                            <td>{{ withdraw.dateApproved }} </td>
                                            <td>{{ withdraw.dateCreated }}</td>
                                            <td>{{ withdraw.amount | currency:'PHP' }}</td>
                                            <td>{{ withdraw.accountNumber }}</td>
                                            <td><a (click)="viewWithdrawDetails(withdraw, withdrawDetails)" style="cursor: pointer;">View</a></td>
                                        </tr>
                                    </ng-container>
                                    <ng-template #noRecords3>
                                        <tr>
                                            <td colspan="8" class="no-records-msg">
                                                <h6 class="ponds-contents-med-bold">No records found</h6>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                        <div class="list-footer">
                            <div class="pager">
                                <button class="pager-prev"><img src="../../../../assets/okito/images/icons/prev.svg"></button>
                                <button class="pager-next"><img src="../../../../assets/okito/images/icons/next.svg"></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel" *ngIf="!this.isLoadingDetail && this.detailTabs['activity']">
                    <div class="list-holder">
                        <div class="tools">
                            <div class="list-title">
                                <h4>Activity History</h4>
                                <!-- total describes the whole history, not this page. -->
                                <small *ngIf="activityTotal">{{ activityTotal | number }} recorded change{{ activityTotal === 1 ? '' : 's' }}</small>
                            </div>
                        </div>
                        <div class="list table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Date &amp; Time</th>
                                        <th>Action</th>
                                        <th>Document</th>
                                        <th>Changed By</th>
                                        <th>What Changed</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="activityHistory.length != 0; else noActivity">
                                        <tr *ngFor="let entry of activityHistory">
                                            <td class="text-nowrap">{{ entry.dateCreated }}</td>
                                            <td><span class="stat" [ngClass]="activityActionClass(entry.action)">{{ historyActionLabel(entry.action) }}</span></td>
                                            <td>{{ activitySubject(entry) }}</td>
                                            <td>
                                                <strong>{{ activityActor(entry) }}</strong>
                                                <div *ngIf="entry.adminEmail"><small>{{ entry.adminEmail }}</small></div>
                                            </td>
                                            <td>
                                                <table class="audit-change-table">
                                                    <tr *ngFor="let change of activityChanges(entry)">
                                                        <td>{{ change.label }}</td>
                                                        <td class="audit-old-value">{{ change.isImage ? (change.oldValue === '—' ? '—' : 'file') : change.oldValue }}</td>
                                                        <td class="audit-new-value">{{ change.isImage ? (change.newValue === '—' ? '—' : 'file') : change.newValue }}</td>
                                                    </tr>
                                                </table>
                                                <span *ngIf="!activityChanges(entry).length">—</span>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <ng-template #noActivity>
                                        <tr>
                                            <td colspan="5" class="no-records-msg">
                                                <h6 class="ponds-contents-med-bold">{{ activityLoading ? 'Loading…' : 'Nothing has been changed on this partner yet.' }}</h6>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                        <div class="list-footer" *ngIf="activityTotalPages > 1">
                            <div class="pager">
                                <button class="pager-prev" type="button" [disabled]="activityPage <= 1"
                                        (click)="nextPrevActivity('prev')">
                                    <img src="../../../../assets/okito/images/icons/prev.svg">
                                </button>
                                <button class="pager-next" type="button" [disabled]="activityPage >= activityTotalPages"
                                        (click)="nextPrevActivity('next')">
                                    <img src="../../../../assets/okito/images/icons/next.svg">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <ng-template #bookingDetail let-offcanvas>
        <div class="offcanvas-header">
            <h5 id="offcanvasRightLabel">
                <small>{{ this.bookingdetailViewed['dateCreated'] | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A' }}</small>
                <small>Booking ID</small>
                {{ (selectedServiceType == 'express') ? this.bookingdetailViewed['bookingExpressId'] :
                this.bookingdetailViewed['bookingRideId'] }}
            </h5>
            <span class="stat stat-canceled" *ngIf="this.bookingdetailViewed['status'] === 'pending'">Pending</span>
            <span class="stat stat-ongoing" *ngIf="this.bookingdetailViewed['status'] === 'accepted'">Accepted</span>
            <span class="stat stat-ongoing" *ngIf="this.bookingdetailViewed['status'] === 'ongoing_pickup'">Ongoing -
                Pickup</span>
            <span class="stat stat-ongoing" *ngIf="this.bookingdetailViewed['status'] === 'ongoing_destination'">Ongoing -
                Destination</span>
            <span class="stat stat-completed" *ngIf="this.bookingdetailViewed['status'] === 'completed'">Completed</span>
            <span class="stat stat-canceled" *ngIf="this.bookingdetailViewed['status'] === 'canceled'">Cancelled</span>
            <button type="button" class="btn-close text-reset" (click)="offcanvas.dismiss('Cross click')"></button>
        </div>
        <div class="offcanvas-body">
            <div class="booking-holder">
                <google-map height="250px" width="370px" [center]="center" [zoom]="zoom" (mapClick)="moveMap($event)"
                    (mapMousemove)="move($event)">
                    <map-polyline [path]="polyLinePath" [options]="polyLineOptions" />
                </google-map>
                <div class="booking-address">
                    <div class="booking-address-details">
                        <img src="./../../../assets/okito/images/pickup.svg">
                        <div class="sender-details">
                            <label>Pick-up Location</label>
                            <h4>{{ this.bookingdetailViewed['startFormattedAddress'] }}</h4>
                            <div class="sender">
                                <span>{{ this.bookingdetailViewed['senderName'] }}</span>
                                <span>{{ this.bookingdetailViewed['senderMobile'] }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="booking-address-details">
                        <img src="./../../../assets/okito/images/dropoff.svg">
                        <div class="sender-details">
                            <h4>{{ this.bookingdetailViewed['endFormattedAddress'] }}</h4>
                            <div class="sender">
                                <span>{{ this.bookingdetailViewed['receipientName'] }}</span>
                                <span>{{ this.bookingdetailViewed['receipientMobile'] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="booking-note">
                    <label>Note to rider</label>
                    <p>{{ this.bookingdetailViewed['notes'] }}</p>
                </div>
                <div class="booking-distance">
                    <div class="fees-grp">
                        <div class="distance-label">
                            <img src="./../../../assets/okito/images/dropoff.svg">
                            <label>Distance</label>
                        </div>
                        <span>{{ (selectedServiceType == 'express') ? this.bookingdetailViewed['totalDistance'] :
                            this.bookingdetailViewed['kmDistance'] }} km</span>
                    </div>
                </div>
                <div class="pwdsc">
                    <div class="pwdsc-id">
                        <img src="./../../../assets/okito/images/pwdsc.png">
                        <div class="pwdsc-info">
                            <label>Discount</label>
                            <h4>PWD/SC/Student Card</h4>
                        </div>
                    </div>
                </div>
                <div class="booking-fees">
                    <div class="fees-grp">
                        <label>Delivery Fee</label>
                        <span>{{ this.bookingdetailViewed['farePrice'] | currency:'PHP' }}</span>
                    </div>
                    <div class="fees-grp">
                        <label>Discount</label>
                        <span class="discount">-{{ this.bookingdetailViewed['discountPrice'] | currency:'PHP' }}</span>
                    </div>
                    <div class="total-fees">
                        <label>Total Delivery Fee</label>
                        <div class="total">
                            <img src="./../../../assets/okito/images/cash.svg">
                            <span>{{ this.bookingdetailViewed['totalPrice'] | currency:'PHP' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>


    <ng-template #withdrawDetails let-offcanvas>
        <div class="offcanvas-header">
            <h5 id="offcanvasRightLabel">
                <small>{{ this.withdrawdetailViewed['dateCreated'] | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A'
                    }}</small>
            </h5>
            <button type="button" class="btn-close text-reset" (click)="offcanvas.dismiss('Cross click')"></button>
        </div>
        <div class="offcanvas-body">
            <div class="booking-holder">
                    <h5>Withdrawal Details</h5>
                    <div class="details-grp">
                        <label>Transaction ID</label>
                        <span>{{ this.withdrawdetailViewed['partnerWalletRequestId'] }}</span>
                    </div>
                    <div class="details-grp">
                        <label>Partner's Mobile Number</label>
                        <span>{{ this.withdrawdetailViewed['accountName'] }}</span>
                    </div>
                    <div class="details-grp">
                        <label>Partner's Email Address</label>
                        <span>{{ this.withdrawdetailViewed['partner']['email'] }}</span>
                    </div>
                    <div class="details-grp">
                        <label>Partner's Name</label>
                        <span>{{ this.withdrawdetailViewed['partner']['firstName'] + ' ' + this.withdrawdetailViewed['partner']['lastName']}}</span>
                    </div>
                    <div class="details-grp">
                        <label>Vehicle Type</label>
                        <span>{{ this.withdrawdetailViewed['partner']['vehicleType'] }}</span>
                    </div>
                    <div class="details-grp">
                        <label>Amount</label>
                        <span>{{ this.withdrawdetailViewed['amount'] | currency:'PHP' }}</span>
                    </div>
                    <div class="details-grp">
                        <label>Top-Up Type</label>
                        <span>{{ withdrawdetailViewed['accountNumber'] | uppercase }}</span>
                    </div>
                    <div class="details-grp">
                        <label>Reference</label>
                        <span>{{ this.withdrawdetailViewed['bankName'] +  ' - ' + this.withdrawdetailViewed['accountNumber']}}</span>
                    </div>
                </div>

        </div>
    </ng-template>


    <ng-template #topupDetails let-offcanvas>
        <div class="offcanvas-header">
            <h5 id="offcanvasRightLabel">
                <small>{{ this.topupdetailViewed['dateCreated'] | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD h:mm:ss A'
                    }}</small>
            </h5>
            <button type="button" class="btn-close text-reset" (click)="offcanvas.dismiss('Cross click')"></button>
        </div>
        <div class="offcanvas-body">
            <div class="booking-holder">
                <h5>Top Up Details</h5>
                <div class="details-grp">
                    <label>Transaction ID</label>
                    <span>{{ this.topupdetailViewed['partnerTopupRequestId'] }}</span>
                </div>
                <div class="details-grp">
                    <label>Partner's Mobile Number</label>
                    <span>{{ this.topupdetailViewed['partner']['mobile'] }}</span>
                </div>
                <div class="details-grp">
                    <label>Partner's Email Address</label>
                    <span>{{ this.topupdetailViewed['partner']['email'] }}</span>
                </div>
                <div class="details-grp">
                    <label>Partner's Name</label>
                    <span>{{ this.topupdetailViewed['partner']['firstName'] + ' ' +
                        this.topupdetailViewed['partner']['lastName']}}</span>
                </div>
                <div class="details-grp">
                    <label>Vehicle Type</label>
                    <span>{{ this.topupdetailViewed['partner']['vehicleType'] }}</span>
                </div>
                <div class="details-grp">
                    <label>Amount</label>
                    <span>{{ this.topupdetailViewed['amount'] | currency:'PHP' }}</span>
                </div>
                <div class="details-grp">
                    <label>Source</label>
                    <span>{{ this.topupdetailViewed['source'] }}</span>
                </div>
            </div>

        </div>
    </ng-template>

</div>


<ng-template #docModalView let-modal id="photo" class="modal">
    <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">{{ this.documentDictionary[this.currentSelectedDocument] }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <!-- ID PHOTO -->
        <div class="modal-form" *ngIf="this.formDocumentType['selfie'] || this.formDocumentType['spa_letter'] || this.formDocumentType['no_modification_certification'] || this.formDocumentType['driving_track_certificate'] || this.formDocumentType['drug_test_certificate'] || this.formDocumentType['id'] || this.formDocumentType['medical_certificate'] || this.formDocumentType['truck_permit']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }}</label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>
                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                            <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)" style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- DRIVERS LICENSE FRONT -->
        <div class="modal-form" *ngIf="this.formDocumentType['drivers_license']['front']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }} (Front)</label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>
                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                        <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)"
                            style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>
            <div class="form-item">
                <label class="form-label">Driver's License ID</label>
                <input type="text" class="form-control" [(ngModel)]="this.selectedDocInfo.idNumber">
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-item">
                        <label class="form-label">First Name</label>
                        <input type="text" class="form-control" [(ngModel)]="this.selectedDocInfo.firstName">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-item">
                        <label class="form-label">Middle Name</label>
                        <input type="text" class="form-control" [(ngModel)]="this.selectedDocInfo.middleName">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-item">
                        <label class="form-label">Last Name</label>
                        <input type="text" class="form-control" [(ngModel)]="this.selectedDocInfo.lastName">
                    </div>
                </div>
            </div>
            <div class="form-item">
                <label class="form-label">Address</label>
                <input type="text" class="form-control" [(ngModel)]="this.selectedDocInfo.address">
            </div>
            <div class="row publish-date">
                <div class="col-md-12">
                    <div class="form-item">
                        <label class="form-label">Expiration Date</label>
                        <div class="form-control-grp">
                            <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="model" ngbDatepicker
                                #d="ngbDatepicker" />
                            <img src="../../../../assets/okito/images/calendar.svg" (click)="d.toggle()" style="cursor: pointer;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-item">
                <label class="form-label">Gender</label>
                <select class="form-select" aria-label="Default select example" [(ngModel)]="this.selectedDocInfo.gender">
                    <option [ngValue]="true">Female</option>
                    <option [ngValue]="false">Male</option>
                </select>
            </div>
        </div>

        <!-- DRIVERS LICENSE BACK -->
        <div class="modal-form" *ngIf="this.formDocumentType['drivers_license']['back']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }} (Back)</label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>
                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                        <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)"
                            style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- INSURANCE -->
        <div class="modal-form" *ngIf="this.formDocumentType['insurance']['front'] || this.formDocumentType['insurance']['back']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }}</label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>
                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                        <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)"
                            style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>

            <div class="row publish-date">
                <div class="col-md-12">
                    <div class="form-item">
                        <label class="form-label">Expiration Date</label>
                        <div class="form-control-grp">
                            <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="model" ngbDatepicker
                                #d="ngbDatepicker" />
                            <img src="../../../../assets/okito/images/calendar.svg" (click)="d.toggle()" style="cursor: pointer;">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- VEHICLE OR -->
        <div class="modal-form" *ngIf="this.formDocumentType['vehicle_registration']['official_receipt']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }} (Official Receipt)</label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>
                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                        <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)"
                            style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>
            <div class="form-item">
                <label class="form-label">OR Number</label>
                <input type="text" class="form-control" [(ngModel)]="this.selectedDocInfo.idNumber">
            </div>
            <div class="row publish-date">
                <div class="col-md-12">
                    <div class="form-item">
                        <label class="form-label">Date Issued</label>
                        <div class="form-control-grp">
                            <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="model" ngbDatepicker
                                #d="ngbDatepicker" />
                            <img src="../../../../assets/okito/images/calendar.svg" (click)="d.toggle()" style="cursor: pointer;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-item">
                <label class="form-label">Plate Number/Conduction Number</label>
                <input type="text" class="form-control" [(ngModel)]="this.selectedDocInfo.address">
            </div>
        </div>

        <!-- VEHICLE CR -->
        <div class="modal-form" *ngIf="this.formDocumentType['vehicle_registration']['certificate_registration']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }} (Certificate of Registration)</label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>
                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                        <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)"
                            style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>
            <div class="form-item">
                <label class="form-label">CR Number</label>
                <input type="text" class="form-control" [(ngModel)]="this.selectedDocInfo.idNumber">
            </div>
            <div class="row publish-date">
                <div class="col-md-12">
                    <div class="form-item">
                        <label class="form-label">Date Issued</label>
                        <div class="form-control-grp">
                            <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="model" ngbDatepicker
                                #d="ngbDatepicker" />
                            <img src="../../../../assets/okito/images/calendar.svg" (click)="d.toggle()" style="cursor: pointer;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-item">
                <label class="form-label">Plate Number/Conduction Number</label>
                <input type="text" class="form-control" [(ngModel)]="this.selectedDocInfo.address">
            </div>
        </div>

        <!-- VEHICLE PHOTO -->
        <form class="modal-form" *ngIf="this.formDocumentType['vehicle_photo']['front'] || this.formDocumentType['vehicle_photo']['left'] || this.formDocumentType['vehicle_photo']['back'] || this.formDocumentType['vehicle_photo']['right']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }} </label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>

                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                        <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)"
                            style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>
        </form>

        <!-- NBI -->
        <form class="modal-form" *ngIf="this.formDocumentType['nbi_certificate']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }}</label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>
                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                        <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)"
                            style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>
            <label style="font-size: 14px;font-weight: italic;" class="form-label">Note: You can try to verify the NBI clearance <a href="https://verification.nbi-clearance.io/" target="_blank">here</a></label>
        </form>

        <!-- GCASH SETTLEMENT -->
        <form class="modal-form" *ngIf="this.formDocumentType['gcash_settlement']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }}</label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>
                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                        <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)"
                            style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>
        </form>

        <!-- TNVS -->
        <form class="modal-form" *ngIf="this.formDocumentType['tnvs_certificate']">
            <div class="form-item">
                <label class="form-label">{{ this.documentDictionary[this.currentSelectedDocument] }}</label>
                <div class="modal-photo">
                    <a (click)="viewLargerModal(viewImageLarger)" style="cursor: pointer;" target="_blank" class="docs">
                        <div class="docs-holder">
                            <img [src]="this.selectedDocInfo['link']" *ngIf="this.selectedDocInfo.link != ''">
                        </div>
                    </a>
                    <div class="btn-photo" *ngIf="this.selectedDocInfo.link != ''">
                        <button type="button" class="btn btn-sm btn-outline" (click)="viewLargerModal(viewImageLarger)" style="margin-right: .5em;">View Attachment</button>
                        <a [href]="this.selectedDocInfo['link']">
                            <button type="button" class="btn btn-sm btn-outline">Download Photo</button>
                        </a>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer" *ngIf="!this.isEditingDocument">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Close</button>
        <button *ngIf="this.selectedDocInfo['status'] !== 'ammendment'" [disabled]="this.detailViewed['status'] == 'approved'" type="button" class="btn btn-outline" (click)="this.showConfirmModal(confirmModal, 'amend')">For Amendment</button>
        <button *ngIf="this.selectedDocInfo['status'] !== 'approve'" [disabled]="this.detailViewed['status'] == 'approved' || isValidatingDocument" type="button" class="btn btn-default" (click)="this.showConfirmModal(confirmModal, 'verify_doc')">
            <i *ngIf="isValidatingDocument" class="fa fa-spinner fa-spin"></i>
            Validate
        </button>
    </div>
    <div class="modal-footer" *ngIf="this.isEditingDocument">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Close</button>
        <button type="button" class="btn btn-default" [disabled]="isUpdatingDocumentDetails" (click)="updateDocumentDetailsById()">
            <i *ngIf="isUpdatingDocumentDetails" class="fa fa-spinner fa-spin"></i>
            Update Document Details
        </button>
    </div>
</ng-template>

<ng-template #overrideModal let-modal id="photo" class="modal">
    <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Override Confirmation</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>Enter the override password to enable document update mode.</p>
        <form class="modal-form">
            <div class="form-item">
                <label class="form-label">Password</label>
                <input type="password" class="form-control" [(ngModel)]="this.overridePassword" name="overridePassword">
                <small class="text-danger" *ngIf="this.overridePasswordError != ''">{{ this.overridePasswordError }}</small>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
        <button type="button" class="btn btn-default" (click)="submitOverridePassword(modal)">Submit</button>
    </div>
</ng-template>

<ng-template #docHistoryModal let-modal id="photo" class="modal">
    <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Document History<ng-container *ngIf="selectedHistoryDoc"> &mdash; {{ this.verifyDocumentName(selectedHistoryDoc.type) }}</ng-container></h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="audit-trail" *ngIf="selectedHistoryDoc && combinedDocumentTrail(selectedHistoryDoc).length; else noHistory">
            <div class="audit-entry" *ngFor="let item of combinedDocumentTrail(selectedHistoryDoc)">
                <div class="audit-entry-header">
                    <strong *ngIf="item.kind === 'history'">Re-uploaded</strong>
                    <span class="latest-tag" *ngIf="item.isLatest">Latest</span>
                    <span *ngIf="item.kind === 'history'">{{ item.entry.type }}<ng-container *ngIf="item.entry.type !== item.entry.subType"> ({{ item.entry.subType }})</ng-container></span>
                    <small>{{ item.dateCreated }}</small>
                </div>
                <table class="audit-diff-table" *ngIf="item.kind === 'audit' && auditFieldChanges(item.entry).length">
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Old Value</th>
                            <th>New Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let change of auditFieldChanges(item.entry)">
                            <td>{{ change.label }}</td>
                            <ng-container *ngIf="!change.isImage">
                                <td class="audit-old-value">{{ change.oldValue }}</td>
                                <td class="audit-new-value">{{ change.newValue }}</td>
                            </ng-container>
                            <ng-container *ngIf="change.isImage">
                                <td><a [href]="change.oldValue" target="_blank"><img class="audit-thumb" [src]="change.oldValue" *ngIf="change.oldValue !== '—'"></a><span *ngIf="change.oldValue === '—'">—</span></td>
                                <td><a [href]="change.newValue" target="_blank"><img class="audit-thumb" [src]="change.newValue" *ngIf="change.newValue !== '—'"></a><span *ngIf="change.newValue === '—'">—</span></td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
                <div class="photo-diff" *ngIf="item.kind === 'history'">
                    <div class="photo-diff-col">
                        <span class="photo-diff-label audit-old-value">Old Photo</span>
                        <a [href]="item.entry.oldLink" target="_blank"><img [src]="item.entry.oldLink" *ngIf="item.entry.oldLink"></a>
                    </div>
                    <div class="photo-diff-col">
                        <span class="photo-diff-label audit-new-value">New Photo</span>
                        <a [href]="item.entry.newLink" target="_blank"><img [src]="item.entry.newLink" *ngIf="item.entry.newLink"></a>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #noHistory>
            <p class="no-records-msg">No history found</p>
        </ng-template>
    </div>
</ng-template>

<ng-template #accountAuditModal let-modal id="photo" class="modal">
    <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Document Audit Trail</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="audit-trail">
            <div class="audit-entry audit-entry-with-preview" *ngFor="let entry of this.partnerAuditTrails">
                <a class="audit-preview-link" [href]="documentThumbForId(entry.partnerDocumentId)" target="_blank" *ngIf="documentThumbForId(entry.partnerDocumentId) as thumb">
                    <img class="audit-preview-thumb" [src]="thumb">
                </a>
                <div class="audit-entry-body">
                    <div class="audit-entry-header">
                        <strong>{{ historyActionLabel(entry.action) }}</strong>
                        <span class="audit-doc-label">{{ documentLabelForId(entry.partnerDocumentId) }}</span>
                        <small>{{ entry.dateCreated }}</small>
                    </div>
                    <table class="audit-diff-table" *ngIf="auditFieldChanges(entry).length">
                        <thead>
                        <tr>
                            <th>Field</th>
                            <th>Old Value</th>
                            <th>New Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let change of auditFieldChanges(entry)">
                            <td>{{ change.label }}</td>
                            <ng-container *ngIf="!change.isImage">
                                <td class="audit-old-value">{{ change.oldValue }}</td>
                                <td class="audit-new-value">{{ change.newValue }}</td>
                            </ng-container>
                            <ng-container *ngIf="change.isImage">
                                <td><a [href]="change.oldValue" target="_blank"><img class="audit-thumb" [src]="change.oldValue" *ngIf="change.oldValue !== '—'"></a><span *ngIf="change.oldValue === '—'">—</span></td>
                                <td><a [href]="change.newValue" target="_blank"><img class="audit-thumb" [src]="change.newValue" *ngIf="change.newValue !== '—'"></a><span *ngIf="change.newValue === '—'">—</span></td>
                            </ng-container>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #successModal let-modal id="photo" class="modal">
    <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Success</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeAllModals()"></button>
    </div>

    <!-- SUCCESS AMEND -->
    <div class="modal-body success-body" *ngIf="this.confirmSelection['amend']">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Partner verification is marked for amendment</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>

    <!-- SUCCESS VALIDATE -->
    <div class="modal-body success-body" *ngIf="this.confirmSelection['verify_doc']">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Document is validated</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>

    <div class="modal-body success-body" *ngIf="this.confirmSelection['verify_partner']">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Partner validated</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>

    <div class="modal-body success-body" *ngIf="this.confirmSelection['remove_doc']">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Document Removed</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>

    <!-- SUCCESS FOLLOW UP -->
    <div class="modal-body success-body" *ngIf="this.confirmSelection['follow_up']">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Follow up Email & SMS notification has been sent</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>
</ng-template>


<ng-template #confirmModal let-modal id="photo" class="modal">
    <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Confirmation</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>

    <!-- FOR AMMEND CONFIRM -->
    <div class="modal-body" *ngIf="this.confirmSelection['amend']">
        <p>Are you sure you want to amend this document?</p>
        <form class="modal-form 1">
            <div class="form-item">
                <label class="form-label">Reason</label>
                <textarea class="form-control" rows="3" [(ngModel)]="selectedDocInfo.notes" name="notes"></textarea>
            </div>
        </form>
    </div>
    <div class="modal-footer" *ngIf="this.confirmSelection['amend']">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default" [disabled]="this.detailViewed['status'] == 'approved' || isValidatingDocument" (click)="validateThisDocument(successModal, 2 , this.detailViewed['partnerId'], this.selectedDocInfo)">
            <i *ngIf="isValidatingDocument" class="fa fa-spinner fa-spin"></i>
            Yes, Amend
        </button>
    </div>

    <!-- FOR CONFIRM VALIDATE DOCS -->
    <div class="modal-body" *ngIf="this.confirmSelection['verify_doc']">
        <p>Are you sure you want to validate this document?</p>
    </div>
    <div class="modal-footer" *ngIf="this.confirmSelection['verify_doc']">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default" [disabled]="isValidatingDocument" (click)="validateThisDocument(successModal, 1,  this.detailViewed['partnerId'], this.selectedDocInfo)">
            <i *ngIf="isValidatingDocument" class="fa fa-spinner fa-spin"></i>
            Yes, Validate
        </button>
    </div>

    <!-- FOR CONFIRM VALIDATE PARTNER -->
    <div class="modal-body" *ngIf="this.confirmSelection['verify_partner']">
        <p>Are you sure you want to validate this partner?</p>
    </div>
    <div class="modal-footer" *ngIf="this.confirmSelection['verify_partner']">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default" (click)="verifyPartner(successModal ,this.detailViewed['partnerId'])">Yes, Validate</button>
    </div>

    <!-- FOR CONFIRM REMOVE DOCUMENT -->
    <div class="modal-body" *ngIf="this.confirmSelection['remove_doc']">
        <p>
            <strong>Remove
                {{ verifyDocumentName(documentForRemoval.type) }}<ng-container
                    *ngIf="documentForRemoval.type !== documentForRemoval.subType">
                    — {{ subDocumentDictionary[documentForRemoval.subType] }}</ng-container>?</strong>
        </p>
        <p>
            This deletes the document and its uploaded file from the partner's record. It cannot be
            undone, and the partner will have to upload it again. The removal is recorded against your
            admin account in the document audit trail.
        </p>
    </div>
    <div class="modal-footer" *ngIf="this.confirmSelection['remove_doc']">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default"
            (click)="removeDocument(documentForRemoval , successModal)">Yes, Remove</button>
    </div>
</ng-template>

<ng-template #viewImageLarger let-modal id="photo" class="modal">
    <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Attachment Viewing</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>

    <div class="modal-body">
        <div class="image-bigviewer">
            <lib-ngx-image-zoom zoomMode="click"
                [thumbImage]="selectedDocInfo.link"
                *ngIf="selectedDocInfo.link"
                [magnification]="1">
            </lib-ngx-image-zoom>
        </div>
    </div>
    <div class="modal-footer">
        <div style="width: 25vh;" *ngIf="!this.detailViewed['isApprove']">
            <button type="button" class="btn btn-outline" (click)="this.showConfirmModal(confirmModal, 'amend')">For
                Amendment</button>
        </div>

        <div style="width: 25vh;" *ngIf="!this.detailViewed['isApprove']">
            <button type="button" class="btn btn-default" [disabled]="isValidatingDocument" (click)="this.showConfirmModal(confirmModal, 'verify_doc')">
                <i *ngIf="isValidatingDocument" class="fa fa-spinner fa-spin"></i>
                Validate
            </button>
        </div>

        <div style="width: 25vh;">
            <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
    </div>
</ng-template>

<ng-template #viewProfileImage let-modal id="photo" class="modal">
    <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Profile Image</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>

    <div class="modal-body">
        <div class="image-bigviewer">
            <lib-ngx-image-zoom zoomMode="click" [thumbImage]="this.profileImage" *ngIf="this.profileImage"
                [magnification]="1">
            </lib-ngx-image-zoom>
        </div>
    </div>
    <div class="modal-footer">
        <div style="width: 25vh;">
            <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
    </div>
</ng-template>

<ng-template #addDocument let-modal class="modal">
    <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Add Document</h5>
    </div>
    <div class="modal-body">
        <div class="modal-form">
            <div class="form-item">
                <label class="form-label">Document</label>
                <select class="form-select" aria-label="Document to add" [(ngModel)]="selectedDocumentSlot">
                    <option value="">Select a document</option>
                    <option *ngFor="let slot of addableDocuments" [value]="slot.value">{{ slot.label }}</option>
                </select>
                <!-- Only slots this partner does not already have are listed. -->
                <small class="form-help" *ngIf="!addableDocuments.length">
                    This partner already has every document on file.
                </small>
            </div>
            <div class="form-item">
                <label class="form-label">Document Photo</label>
                <div class="modal-upload-photo">
                    <input type="file" class="input-file" id="modal-input-file" (change)="onFileSelected($event)"
                        accept="image/*">
                    <div class="docs-holder">
                        <img [src]="this.imageSrc" *ngIf="this.imageSrc != undefined">
                    </div>
                    <div class="btn-photo">
                        <label for="modal-input-file" class="btn btn-sm btn-outline">Upload Photo</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
        <button type="button" class="btn btn-default" (click)="createDocumentData(confirmAddDocument)">Add this Document</button>
    </div>
</ng-template>

<ng-template #confirmAddDocument let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p>Are you sure you want to add this Document?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">No, Cancel it</button>
        <button type="button" class="btn btn-default" (click)="proceedCreateDocumentData(successCreate)">Yes, Add</button>
    </div>
</ng-template>

<ng-template #successCreate let-modal class="modal">
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body success-body">
        <img src="../../../../assets/okito/images/modal-success.svg">
        <p>Document successfully created</p>
        <button class="btn btn-default" (click)="closeAllModals()">Close</button>
    </div>
</ng-template>

<ng-template #vehicleDetailsModal let-modal class="modal">
    <div class="modal-header">
        <h5 class="modal-title">Vehicle Details</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <form class="modal-form">
            <div class="form-item">
                <label class="form-label">Vehicle Category</label>
                <input type="text" class="form-control" disabled [value]="vehicleCategory">
            </div>
            <div class="form-item">
                <label class="form-label">Vehicle Type</label>
                <input type="text" class="form-control" disabled [value]="vehicleTypeLabel">
            </div>
            <div class="form-item">
                <label class="form-label">Vehicle Make</label>
                <input type="text" class="form-control" disabled [value]="vehicleMake">
            </div>
            <div class="form-item">
                <label class="form-label">Vehicle Model</label>
                <input type="text" class="form-control" disabled [value]="vehicleModel">
            </div>
            <div class="form-item">
                <label class="form-label">Vehicle Year</label>
                <input type="text" class="form-control" disabled [value]="vehicleYear">
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="modal.dismiss('Cross click')">Close</button>
    </div>
</ng-template>
